import * as leaflet from 'leaflet'

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      L,
    },
  }
})
